import { c as _c } from "react/compiler-runtime";
import { useMemo } from "react";
import { useWidgetSelector } from "../../../store/store";
import { State } from "../../../store/state";
import { ShareType } from "../../../types/Enums";
import { CauseArea } from "../../../types/CauseArea";
export const useAmountCalculation = (selectionType, selectedCauseAreaId, causeAreas) => {
  const $ = _c(32);
  const {
    causeAreaAmounts: t0,
    orgAmounts: t1,
    causeAreaDistributionType: t2,
    operationsConfig,
    smartDistributionTotal: t3
  } = useWidgetSelector(_temp);
  let t4;
  if ($[0] !== t0) {
    t4 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const causeAreaAmounts = t4;
  let t5;
  if ($[2] !== t1) {
    t5 = t1 === undefined ? {} : t1;
    $[2] = t1;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const orgAmounts = t5;
  let t6;
  if ($[4] !== t2) {
    t6 = t2 === undefined ? {} : t2;
    $[4] = t2;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const causeAreaDistributionType = t6;
  const smartDistributionTotal = t3 === undefined ? 0 : t3;
  const OPERATIONS_CAUSE_AREA_ID = operationsConfig?.operationsCauseAreaId;
  let t7;
  if ($[6] !== OPERATIONS_CAUSE_AREA_ID || $[7] !== causeAreaAmounts || $[8] !== causeAreaDistributionType || $[9] !== causeAreas || $[10] !== orgAmounts || $[11] !== selectedCauseAreaId || $[12] !== selectionType) {
    t7 = Object.keys(causeAreaAmounts).reduce((acc, key) => {
      const causeAreaId = parseInt(key);
      if (causeAreaId === OPERATIONS_CAUSE_AREA_ID) {
        return acc;
      }
      if (selectionType === "single" && selectedCauseAreaId !== causeAreaId) {
        return acc;
      }
      let amountForThisCauseArea = 0;
      if (causeAreaDistributionType[causeAreaId] === ShareType.CUSTOM) {
        const currentCauseArea = causeAreas.find(ca => ca.id === causeAreaId);
        if (currentCauseArea) {
          amountForThisCauseArea = currentCauseArea.organizations.reduce((orgSum, org) => orgSum + (Number(orgAmounts[org.id]) || 0), 0);
        }
      } else {
        amountForThisCauseArea = Number(causeAreaAmounts[causeAreaId]) || 0;
      }
      return acc + amountForThisCauseArea;
    }, 0);
    $[6] = OPERATIONS_CAUSE_AREA_ID;
    $[7] = causeAreaAmounts;
    $[8] = causeAreaDistributionType;
    $[9] = causeAreas;
    $[10] = orgAmounts;
    $[11] = selectedCauseAreaId;
    $[12] = selectionType;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const sumOfOtherCauseAreas = t7;
  let t8;
  if ($[14] !== OPERATIONS_CAUSE_AREA_ID || $[15] !== causeAreaAmounts || $[16] !== causeAreaDistributionType || $[17] !== causeAreas || $[18] !== operationsConfig?.excludedCauseAreaIds || $[19] !== orgAmounts || $[20] !== selectedCauseAreaId || $[21] !== selectionType || $[22] !== smartDistributionTotal) {
    t8 = () => {
      let currentTotal = 0;
      if (selectedCauseAreaId === -1) {
        currentTotal = causeAreas.reduce((acc_0, area) => {
          if (causeAreaDistributionType[area.id] === ShareType.CUSTOM && area.id !== OPERATIONS_CAUSE_AREA_ID) {
            return acc_0 + area.organizations.reduce((orgAcc, org_0) => orgAcc + (orgAmounts[org_0.id] || 0), 0);
          }
          return acc_0 + (causeAreaAmounts[area.id] || 0);
        }, 0);
      } else {
        if (selectionType === "multiple") {
          const excludedCauseAreaIds = operationsConfig?.excludedCauseAreaIds ?? [];
          currentTotal = causeAreas.filter(ca_0 => !excludedCauseAreaIds.includes(ca_0.id) && ca_0.id !== OPERATIONS_CAUSE_AREA_ID).reduce((acc_1, area_0) => {
            if (causeAreaDistributionType[area_0.id] === ShareType.CUSTOM) {
              return acc_1 + area_0.organizations.reduce((orgAcc_0, org_1) => orgAcc_0 + (orgAmounts[org_1.id] || 0), 0);
            }
            return acc_1 + (causeAreaAmounts[area_0.id] || 0);
          }, 0);
          currentTotal = currentTotal + smartDistributionTotal;
        } else {
          if (selectionType === "single" && selectedCauseAreaId != null) {
            const selectedArea = causeAreas.find(area_1 => area_1.id === selectedCauseAreaId);
            if (selectedArea) {
              if (causeAreaDistributionType[selectedCauseAreaId] === ShareType.STANDARD) {
                currentTotal = 0 + (causeAreaAmounts[selectedCauseAreaId] || 0);
              } else {
                currentTotal = 0 + selectedArea.organizations.reduce((orgAcc_1, org_2) => orgAcc_1 + (orgAmounts[org_2.id] || 0), 0);
              }
            }
          }
        }
      }
      return currentTotal;
    };
    $[14] = OPERATIONS_CAUSE_AREA_ID;
    $[15] = causeAreaAmounts;
    $[16] = causeAreaDistributionType;
    $[17] = causeAreas;
    $[18] = operationsConfig?.excludedCauseAreaIds;
    $[19] = orgAmounts;
    $[20] = selectedCauseAreaId;
    $[21] = selectionType;
    $[22] = smartDistributionTotal;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  operationsConfig?.excludedCauseAreaIds;
  let t9;
  if ($[24] !== t8) {
    t9 = t8();
    $[24] = t8;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  const totalAmount = t9;
  let t10;
  if ($[26] !== causeAreaAmounts || $[27] !== causeAreaDistributionType || $[28] !== orgAmounts || $[29] !== sumOfOtherCauseAreas || $[30] !== totalAmount) {
    t10 = {
      sumOfOtherCauseAreas,
      totalAmount,
      causeAreaAmounts,
      orgAmounts,
      causeAreaDistributionType
    };
    $[26] = causeAreaAmounts;
    $[27] = causeAreaDistributionType;
    $[28] = orgAmounts;
    $[29] = sumOfOtherCauseAreas;
    $[30] = totalAmount;
    $[31] = t10;
  } else {
    t10 = $[31];
  }
  return t10;
};
function _temp(state) {
  return state.donation;
}